module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Perfil de Acesso")])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, _vm._l((_vm.roles), function(role) {
    return _c('div', {
      key: role.code
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedRole),
        expression: "selectedRole"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": role,
        "checked": _vm._q(_vm.selectedRole, role)
      },
      on: {
        "change": function($event) {
          _vm.selectedRole = role
        }
      }
    }), _vm._v("\n      " + _vm._s(_vm.$t((role + ".label"))) + "\n    ")])])
  }), 0), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("Salvar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0179aad2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/ModalUserRoles.vue
// module id = 2865
// module chunks = 0